// Intrinsic [width, height] of public images, used to reserve layout space
// and prevent cumulative layout shift (CLS) as images load.
export const IMG_DIMS = {
  "/journal-brides-today-1.webp": [2000, 1262],
  "/journal-brides-today-2.webp": [2000, 1262],
  "/journal-brides-today-puneet.webp": [642, 942],
  "/journal-ibiza-chefs.webp": [1125, 2000],
  "/journal-ibiza-tablescape.webp": [1125, 2000],
  "/journal-ibiza-team.webp": [2000, 1125],
  "/journal-ibiza.webp": [1200, 456],
  "/journal-ibrahim-kothi-menu.webp": [1180, 2000],
  "/journal-kareena-ibrahim-kothi.webp": [645, 970],
  "/journal-food-mango.webp": [921, 1065],
  "/journal-food-oysters.webp": [921, 971],
  "/journal-food-thali.webp": [921, 934],
  "/journal-lisbon.webp": [1400, 1867],
  "/journal-monaco.webp": [1400, 1660],
  "/journal-udaipur-lake.webp": [1125, 2000],
  "/journal-udaipur-reception.webp": [1125, 2000],
  "/journal-venice.webp": [1400, 2098],
  "/jf-6622.webp": [921, 629],
  "/jf-6625.webp": [921, 1151],
  "/jf-6627.webp": [921, 766],
  "/jf-6628.webp": [921, 1152],
  "/jf-6629.webp": [921, 921],
  "/jf-6630.webp": [921, 921],
  "/jf-6631.webp": [921, 970],
  "/jf-6633.webp": [921, 921],
  "/jf-bruschetta.webp": [921, 1151],
  "/jf-chefs.webp": [921, 898],
  "/jf-cobalt.webp": [921, 1037],
  "/jf-coonoor.webp": [921, 665],
  "/jf-hotpot.webp": [921, 890],
  "/jf-kansa.webp": [921, 753],
  "/jf-kashmir.webp": [921, 874],
  "/jf-kolkata.webp": [921, 836],
  "/jf-kulfi-smoke.webp": [1320, 1609],
  "/jf-pakodas.webp": [921, 1062],
  "/jf-prawns.webp": [921, 922],
  "/jf-ranthambore-2.webp": [1320, 1360],
  "/jf-ranthambore.webp": [1320, 1535],
  "/jf-tiramisu.webp": [921, 822],
  "/jf6596.webp": [921, 458],
  "/jf6597.webp": [921, 1086],
  "/jf6598.webp": [921, 1195],
  "/jf6599.webp": [921, 1112],
  "/jf6600.webp": [921, 1177],
  "/jf6601.webp": [921, 735],
  "/jf6603.webp": [921, 1083],
  "/jf6604.webp": [921, 1207],
  "/jf6606.webp": [921, 1060],
};
